import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { useAdmin } from '../../context/AdminContext';
import AdminHeader from './AdminHeader';

const AdminLayout: React.FC = () => {
  const { setAdminMode } = useAdmin();
  
  useEffect(() => {
    setAdminMode(true);
    
    return () => setAdminMode(false);
  }, [setAdminMode]);
  
  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      <AdminSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <AdminHeader />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-admin-color-primary-50 dark:bg-admin-color-primary-900 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
